export default __webpack_public_path__ + "static/media/food.def4636a.jpg";